import { Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-filling-rts-progress',
  templateUrl: './filling-rts-progress.component.html',
  styleUrls: ['./filling-rts-progress.component.scss']
})
export class FillingRtsProgressComponent implements OnChanges {
  @Input() totalWeight: number = 0;
  @Input() assignedWeight: number = 0;
  remainingWeight: number = 0;

  get progress(): number {
    if (!this.totalWeight || this.totalWeight <= 0) {
      return 0;
    }
    const value = this.assignedWeight / this.totalWeight;
    // Ограничиваем прогресс от 0 до 1
    return Math.max(0, Math.min(1, value));
  }

  ngOnChanges() {
    const total = Number(this.totalWeight) || 0;
    const assigned = Number(this.assignedWeight) || 0;
    // Остаток не должен уходить в минус
    this.remainingWeight = Math.max(0, total - assigned);
  }
}
